import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GettenantComponent } from './gettenant.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { GettenantRoutingModule } from './gettenant-routing.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { TenantMyAccountComponent } from './tenant-my-account/tenant-my-account.component';
import {MatDividerModule} from '@angular/material/divider';
import { MatTabsModule } from '@angular/material/tabs';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {MatSelectModule} from '@angular/material/select';
import {MatCardModule} from '@angular/material/card';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    GettenantComponent,
    TenantMyAccountComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    GettenantRoutingModule,
    IconsModule,
    MatDividerModule,
    MatTabsModule,
    ClipboardModule,
    MatSelectModule,
    MatCardModule,
    MatProgressSpinnerModule,
    FormsModule
  ]
})
export class GettenantModule { }
